import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Text, Button } from "./AcceptCookieStyles";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import ReplaceText from "../ReplaceText";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import { isMobile } from "react-device-detect";

const cookies = new Cookies();

const AcceptCookie = () => {
  const { t, i18n } = useTranslation();
  const [acceptCookie, setAcceptCookie] = useState(cookies.get("acceptCookie"));

  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";

  const agreePolicy = () => {
    setAcceptCookie(true);
    cookies.set("acceptCookie", "true");
  };

  const [showLink, setShowLink] = useState(false);
  const [link, setLink] = useState("");

  useEffect(() => {
    setAcceptCookie(cookies.get("acceptCookie"));
  }, [acceptCookie]);

  if (acceptCookie) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "rgb(44, 62, 80)",
        position: "sticky",
        bottom: 0,
      }}
    >
      <Container
        style={{
          width: "100%",
          color: "white",
          padding: "20px 0px",
          ...(isMobile ? { paddingLeft: 8, paddingRight: 8 } : {}),
        }}
      >
        <Row style={{ padding: 0, margin: 0 }}>
          <Col style={{ padding: 0, margin: 0 }} xs={0} sm={1} md={1} lg={1} />
          <Col
            style={{ padding: 0, margin: 0 }}
            xs={12}
            sm={10}
            md={10}
            lg={10}
          >
            <div
              style={{
                ...(isMobile
                  ? { display: "block" }
                  : { display: "inline-flex" }),
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.8em",
                }}
              >
                <Text isChinese={{ useChinese }}>
                  {t("cookies.cookies_experience")}
                </Text>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  ...(isMobile ? { float: "right", paddingTop: 10 } : {}),
                }}
              >
                <Button
                  onClick={agreePolicy}
                  style={{ marginLeft: 10, color: `#2c3e50` }}
                  isChinese={{ useChinese }}
                >
                  {t("cookies.agree")}
                </Button>
                <Button
                  isChinese={{ useChinese }}
                  onClick={() => {
                    setShowLink(true);
                    setLink(t("form.termsAndConditionsURL"));
                  }}
                  style={{ marginLeft: 10, color: `#2c3e50` }}
                >
                  {t("cookies.more_info")}
                </Button>
              </div>
            </div>
          </Col>
          <Col style={{ padding: 0, margin: 0 }} xs={0} sm={1} md={1} lg={1} />
        </Row>

        <Modal show={showLink} size="xl" onHide={() => setShowLink(false)}>
          <Modal.Header closeButton></Modal.Header>
          <div style={{ height: 600 }}>
            <iframe src={link} style={{ width: "100%", height: "100%" }} />
          </div>
        </Modal>
      </Container>
    </div>
  );
};

export default AcceptCookie;
